/* ByAnyMeans repair pass: progressive navigation and safe product selection. */
(function () {
  'use strict';
  function chooseVariant(variants, selected) {
    return variants.find(function (variant) {
      return variant.options.length === selected.length && selected.every(function (value, index) { return variant.options[index] === value; });
    }) || null;
  }
  function validQuantity(value) { var number = Number(value); return Number.isInteger(number) && number >= 1; }
  if (typeof module !== 'undefined' && module.exports) module.exports = { chooseVariant: chooseVariant, validQuantity: validQuantity };
  if (typeof document === 'undefined') return;
  function eachRoot(scope, selector, callback) {
    if (scope.matches && scope.matches(selector)) callback(scope);
    scope.querySelectorAll(selector).forEach(callback);
  }
  function initHeader(root) {
    if (root.dataset.bamReady) return;
    root.dataset.bamReady = 'true';
    var toggle = root.querySelector('#menuToggle'), mobile = root.querySelector('#mobileMenu');
    function closeMobile(returnFocus) {
      mobile.hidden = true; mobile.classList.remove('open'); toggle.classList.remove('open');
      toggle.setAttribute('aria-expanded', 'false'); toggle.setAttribute('aria-label', 'Open navigation');
      document.body.classList.remove('menu-open');
      if (returnFocus) toggle.focus();
    }
    toggle.addEventListener('click', function () {
      if (!mobile.hidden) { closeMobile(true); return; }
      mobile.style.top = Math.max(0, root.getBoundingClientRect().bottom) + 'px';
      mobile.hidden = false; mobile.classList.add('open'); toggle.classList.add('open');
      toggle.setAttribute('aria-expanded', 'true'); toggle.setAttribute('aria-label', 'Close navigation');
      document.body.classList.add('menu-open');
      var first = mobile.querySelector('a[href]'); if (first) first.focus();
    });
    root.addEventListener('keydown', function (event) {
      if (mobile.hidden) return;
      if (event.key === 'Escape') { event.preventDefault(); closeMobile(true); }
      if (event.key === 'Tab') {
        var focusable = [toggle].concat(Array.from(mobile.querySelectorAll('a[href],button:not([disabled])')));
        var first = focusable[0], last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    });
    mobile.addEventListener('click', function (event) { if (event.target.closest('a[href]')) closeMobile(false); });
    window.addEventListener('resize', function () { if (window.innerWidth > 1024) closeMobile(false); });
    root.querySelectorAll('[data-bam-dropdown]').forEach(function (dropdown) {
      var button = dropdown.querySelector('button'), menu = dropdown.querySelector('.header__dropdown-menu');
      function setOpen(open) { menu.hidden = !open; dropdown.classList.toggle('is-open', open); button.setAttribute('aria-expanded', String(open)); }
      setOpen(false);
      button.addEventListener('click', function () { setOpen(menu.hidden); });
      dropdown.addEventListener('pointerenter', function () { if (window.matchMedia('(hover: hover)').matches) setOpen(true); });
      dropdown.addEventListener('pointerleave', function () { if (!dropdown.contains(document.activeElement)) setOpen(false); });
      dropdown.addEventListener('focusout', function () { setTimeout(function () { if (!dropdown.contains(document.activeElement)) setOpen(false); }, 0); });
      dropdown.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') { event.preventDefault(); setOpen(false); button.focus(); }
        else if (event.key === 'ArrowDown' && event.target === button) { event.preventDefault(); setOpen(true); var link = menu.querySelector('a'); if (link) link.focus(); }
      });
      document.addEventListener('click', function (event) { if (!dropdown.contains(event.target)) setOpen(false); });
    });
  }
  function initProduct(root) {
    if (root.dataset.bamReady) return;
    var data = root.querySelector('[data-bam-variants]'), variants;
    try { variants = JSON.parse(data.textContent); } catch (error) { return; }
    var select = root.querySelector('[data-bam-variant-select]'), form = select && select.form;
    if (!select || !form || !Array.isArray(variants) || !variants.length) return;
    root.dataset.bamReady = 'true';
    var add = root.querySelector('[data-bam-add]'), dynamic = root.querySelector('[data-bam-dynamic]');
    var status = root.querySelector('[data-bam-variant-status]'), quantity = root.querySelector('[data-bam-quantity]');
    var current = variants.find(function (v) { return String(v.id) === select.value; }) || null;
    var changing = false;
    function showImage(button) {
      var img = root.querySelector('[data-bam-main-img]'), frame = root.querySelector('[data-bam-main-image]');
      if (!img || !button) return;
      img.srcset = button.dataset.srcset; img.src = button.dataset.src; img.alt = button.dataset.alt || '';
      img.width = Number(button.dataset.width); img.height = Number(button.dataset.height);
      frame.style.setProperty('--bam-image-ratio', button.dataset.ratio || '0.75');
      root.querySelectorAll('[data-bam-image]').forEach(function (thumb) { var active = thumb === button; thumb.classList.toggle('active', active); thumb.setAttribute('aria-pressed', String(active)); });
    }
    root.querySelectorAll('[data-bam-image]').forEach(function (button) { button.addEventListener('click', function () { showImage(button); }); });
    function applyVariant(variant, notify) {
      current = variant; select.value = variant ? String(variant.id) : '';
      var available = Boolean(variant && variant.available);
      add.disabled = !available;
      add.textContent = available ? 'Add To Cart · ' + variant.price : (variant ? 'Sold Out' : 'Choose an available option');
      if (dynamic) { dynamic.hidden = !available; dynamic.inert = !available; }
      root.querySelector('[data-bam-current-price]').textContent = variant ? variant.price : 'Unavailable combination';
      var compare = root.querySelector('[data-bam-compare-price]'), sale = root.querySelector('[data-bam-sale]');
      compare.textContent = variant && variant.compare ? variant.compare : ''; compare.hidden = !(variant && variant.compare); sale.hidden = compare.hidden;
      status.textContent = !variant ? 'This combination is not offered. Choose another size or color.' : (available ? '' : 'This option is sold out. Choose another available option.');
      if (variant) root.querySelectorAll('[data-bam-option-group]').forEach(function (group, index) {
        group.querySelectorAll('[data-bam-option]').forEach(function (button) { var active = button.dataset.value === variant.options[index]; button.classList.toggle('active', active); button.setAttribute('aria-pressed', String(active)); });
      });
      if (variant && variant.imageId) {
        var image = Array.from(root.querySelectorAll('[data-bam-image]')).find(function (thumb) { return thumb.dataset.imageId === String(variant.imageId); });
        if (image) showImage(image);
      }
      if (notify) {
        var url = new URL(window.location.href);
        if (variant) url.searchParams.set('variant', variant.id); else url.searchParams.delete('variant');
        window.history.replaceState({}, '', url.toString());
        changing = true; select.dispatchEvent(new Event('change', { bubbles: true })); changing = false;
      }
    }
    root.querySelectorAll('[data-bam-option]').forEach(function (button) {
      button.addEventListener('click', function () {
        button.parentElement.querySelectorAll('[data-bam-option]').forEach(function (other) { var active = other === button; other.classList.toggle('active', active); other.setAttribute('aria-pressed', String(active)); });
        var selected = Array.from(root.querySelectorAll('[data-bam-option-group]')).map(function (group) { var active = group.querySelector('[aria-pressed="true"]'); return active ? active.dataset.value : null; });
        applyVariant(chooseVariant(variants, selected), true);
      });
    });
    select.addEventListener('change', function () {
      if (changing) return;
      var variant = variants.find(function (v) { return String(v.id) === select.value; }) || null;
      if (variant) root.querySelectorAll('[data-bam-option-group]').forEach(function (group, index) {
        group.querySelectorAll('[data-bam-option]').forEach(function (button) { var active = button.dataset.value === variant.options[index]; button.classList.toggle('active', active); button.setAttribute('aria-pressed', String(active)); });
      });
      applyVariant(variant, true);
    });
    root.querySelectorAll('[data-bam-qty]').forEach(function (button) { button.addEventListener('click', function () { var previous = parseInt(quantity.value, 10); quantity.value = String(Math.max(1, (Number.isFinite(previous) ? previous : 1) + Number(button.dataset.bamQty))); quantity.dispatchEvent(new Event('change', { bubbles: true })); }); });
    form.addEventListener('submit', function (event) {
      if (!current || !current.available) { event.preventDefault(); status.textContent = 'Choose an available option before adding this product.'; return; }
      if (!validQuantity(quantity.value)) { event.preventDefault(); quantity.reportValidity(); quantity.focus(); }
    });
    root.querySelector('[data-bam-option-controls]').hidden = false;
    root.querySelector('[data-bam-variant-fallback]').hidden = true;
    applyVariant(current, false);
  }
  function initQuickForm(form) {
    if (form.dataset.bamReady) return;
    var select = form.querySelector('select[name="id"]'), button = form.querySelector('button[type="submit"]');
    if (!select || !button) return;
    form.dataset.bamReady = 'true'; select.required = true;
    var label = button.textContent;
    function validSelection() { var option = select.options[select.selectedIndex]; return Boolean(select.value && option && !option.disabled); }
    function update() { var valid = validSelection(); button.disabled = !valid; button.textContent = valid ? label : 'Choose size / option'; }
    select.addEventListener('change', update);
    form.addEventListener('submit', function (event) { if (!validSelection()) { event.preventDefault(); select.reportValidity(); select.focus(); } });
    update();
  }
  function init(scope) {
    eachRoot(scope, '[data-bam-header]', initHeader);
    eachRoot(scope, '[data-bam-product]', initProduct);
    eachRoot(scope, '.bam-quick-form,.ndc-quick', initQuickForm);
    scope.querySelectorAll('.shopify-policy__body a:not([href]),.shopify-policy__body a[href=""]').forEach(function (anchor) {
      if (anchor.textContent.trim().toLowerCase() === 'info@byanymeansshop.com') anchor.href = 'mailto:info@byanymeansshop.com';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
